import type { Novidade } from './tipos';

/** Ficha 2026-11-03: formulário de reunião igual ao do Google Agenda, sem serviço nem cliente. */
export const novidadeReuniaoLivre: Novidade = {
  id: '2026-11-03-reuniao-livre',
  publicada_em: '2026-11-03',
  tipo: 'melhoria',
  modulo: 'agenda',
  permissao: 'agenda.criar',
  textos: {
    pt: {
      titulo: 'Marque reunião como no Google Agenda',
      resumo: 'Agendar reunião agora só pede título e horário, com convidados, local e Google Meet, sem serviço nem cliente.',
      passos: [
        'Em CRM > Reuniões/Agenda ou em Agenda > Semana, Dia e Mês, clique em Agendar reunião ou num horário do calendário. Nas fichas de contato, empresa e negociação, use Criar novo... > Criar reunião.',
        'Preencha o título e o horário. Dia inteiro, repetição, convidados, local e descrição são opcionais. Com o Google conectado, o convite sai pela sua conta; sem ele, por e-mail do sistema.',
        'Marque Adicionar Google Meet: o link aparece na reunião em instantes. Para usar, conecte o Google em Minha conta > Perfil.',
        'Na tarefa do tipo Reunião, os campos são os mesmos. O agendamento com serviço continua em Agendar serviço, na Agenda.',
      ],
    },
    en: {
      titulo: 'Book meetings like in Google Calendar',
      resumo: 'Booking a meeting now only asks for a title and a time, with guests, location and Google Meet, no service or customer.',
      passos: [
        'In CRM > Meetings/Calendar or in Schedule > Week, Day and Month, click Book meeting or a time on the calendar. On contact, company and deal records, use Create new... > Create meeting.',
        'Fill in the title and the time. All day, repeat, guests, location and description are optional. With Google connected, the invite goes out from your account; without it, by system e-mail.',
        'Check Add Google Meet: the link shows up in the meeting in a moment. To use it, connect Google in My account > Profile.',
        'In a task of the Meeting type, the fields are the same. Booking with a service stays in Book a service, in the Schedule.',
      ],
    },
    es: {
      titulo: 'Agenda reuniones como en Google Calendar',
      resumo: 'Agendar una reunión ahora solo pide título y horario, con invitados, lugar y Google Meet, sin servicio ni cliente.',
      passos: [
        'En CRM > Reuniones/Agenda o en Agenda > Semana, Día y Mes, haz clic en Agendar reunión o en un horario del calendario. En las fichas de contacto, empresa y negociación, usa Crear nuevo... > Crear reunión.',
        'Completa el título y el horario. Todo el día, repetición, invitados, lugar y descripción son opcionales. Con Google conectado, la invitación sale de tu cuenta; sin él, por correo del sistema.',
        'Marca Agregar Google Meet: el enlace aparece en la reunión en unos instantes. Para usarlo, conecta Google en Mi cuenta > Perfil.',
        'En la tarea de tipo Reunión, los campos son los mismos. La cita con servicio sigue en Agendar servicio, en la Agenda.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
  rota: '/crm/reunioes',
  imagens: ['/novidades/2026-11-03-reuniao-livre/formulario.webp', null, null, null],
};
